import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

import * as faqSectionStyles from "../../styles/landing_pages/FaqSection.module.css"

export default function FaqSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `faq-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const bannerInformationTitle = ChildSelector.select(
    content,
    `banner-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const bannerInformation = ChildSelector.select(
    content,
    `banner-info`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const answer = content.childNodes
    .filter(node => node.classNames.includes("answer"))
    .map(t => t.text)

  const question = content.childNodes
    .filter(node => node.classNames.includes("question"))
    .map(q => q.text)

  return (
    <div className={`row ${props.className} ${faqSectionStyles.wrapper}`}>
      <div className={`col-12 ${faqSectionStyles.heading}`}>
        <h1
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </div>
      <div
        className={`row ${props.className} ${faqSectionStyles.contentWrapper}`}
      >
        <div className={`col-12 ${props.className} ${faqSectionStyles.content}`}>
          {question.map((q, idx) => (
            <span key={idx}>
              <h4>{q}</h4>
              <p>{answer[idx]}</p>
            </span>
          ))}
        </div>
        {/* <div className={`col-6 ${faqSectionStyles.banner}`}>
          <h2>{bannerInformationTitle}</h2>
          <p>{bannerInformation}</p>
          <WPImage
            holder={content}
            selector={`banner`}
            mode={DISPLAY_MODE.normal}
          />

          <WPCta
            holder={content}
            selector={`register-btn`}
            translate={true}
            className={`${faqSectionStyles.registerBtn}`}
            pageContext={props.pageContext}
          />
        </div> */}
      </div>
    </div>
  )
}
